import { Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { IBreadCrumb } from './breadcrumb.interface';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { SkillRepositoryService } from 'src/app/views/skill-repository/skill-repository.service';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  public breadcrumbs: IBreadCrumb[]
  Url = '';
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private servie: SkillRepositoryService
  ) {
    this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
  }

  ngOnInit() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      distinctUntilChanged(),
    ).subscribe(() => {
      this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
    })
  }
  buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadCrumb[] = []): IBreadCrumb[] {
    const routeConfig = route.routeConfig;
  
    if (routeConfig && routeConfig.data) {
      this.Url = '';
      const breadcrumbLabel = routeConfig.data.breadcrumb;
  
      // Split and trim each label immediately
      let breadcrumbLabels = breadcrumbLabel
        ? breadcrumbLabel.split('/').map(label => label.trim())
        : [];
  
      const role = (localStorage.getItem('role') || '').split(',');
      const isPrivilegedUser = role.some(r =>
        r === GsdRoles.Admin ||
        r === GsdRoles.CompetencyLeader ||
        r === GsdRoles.SubCompetencyLeader || 
        r === GsdRoles.SuperAdmin ||
        r === GsdRoles.Leadership
      );
  
      // Remove 'Home' if user is not privileged
      if (!isPrivilegedUser && breadcrumbLabels[0] === 'Home') {
        breadcrumbLabels.shift();
      }
  
      for (let i = 0; i < breadcrumbLabels.length; i++) {
        let label = breadcrumbLabels[i];
        if (!label.startsWith(":")) {
          this.Url = this.Url + '/' + label;
        } else {
          const paramName = label.slice(1);
          label = route.snapshot.params[paramName];
          this.Url = this.Url + '/' + label;
        }
  
        const breadcrumb: IBreadCrumb = {
          label: label,
          url: this.Url,
        };
  
        if (breadcrumb.label) {
          breadcrumbs.push(breadcrumb);
        }
      }
    }
  
    if (route.firstChild) {
      return this.buildBreadCrumb(route.firstChild, url, breadcrumbs);
    }
    return breadcrumbs;
  }




}